import { Html5Qrcode } from 'html5-qrcode';
import { useEffect, useRef } from 'react';

import { config } from '~shared/config';

type ScannerProps = {
	onDetect: (value: string) => void;
};

export function Scanner({ onDetect }: ScannerProps) {
	const scannerRef = useRef<Html5Qrcode | null>(null);
	const readerId = 'reader'; // ID контейнера

	useEffect(() => {
		const startScanner = async () => {
			// Очищаем контейнер перед созданием нового экземпляра
			const readerElement = document.getElementById(readerId);
			if (readerElement) {
				readerElement.innerHTML = '';
			}

			if (!scannerRef.current) {
				const scanner = new Html5Qrcode(readerId);

				try {
					await scanner.start(
						{ facingMode: 'environment' }, // Основная камера (можно заменить на "user" для фронталки)
						{ fps: 10 },
						decodedText => {
							if (decodedText === config.smenaUrl) return;
							scanner.stop(); // Останавливаем камеру после успешного сканирования
							onDetect(decodedText);
						},
						() => {},
					);
					scannerRef.current = scanner;
				} catch (error) {
					console.error('Ошибка запуска сканера:', error);
				}
			}
		};

		startScanner().then(() => {
			console.log('Scanning...');
		});

		return () => {
			if (scannerRef.current) {
				if (scannerRef.current.isScanning) scannerRef.current.stop().catch(console.error);
				scannerRef.current = null;
			}
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return <div id={readerId} style={{ width: '100%' }}></div>;
}
